module.exports = __webpack_public_path__ + "static/redux-7942dc951ec18a5491c1121274475b03.png";